<template>
  <div class="pa-4">
    <v-dialog v-model="dialog" v-if="dialog" scrollable max-width="90%" persistent :transition="false">

      <v-card class="mt-2 py-2">
        <v-card-title class="">
            <span class="text-h5">Delivery Order Detail</span>
            <v-spacer></v-spacer>
            <v-icon color="white" @click="dialog = false">mdi-close</v-icon>
        </v-card-title>    
        <v-divider></v-divider>
        <v-card-text class="mt-3">
          <v-row class="mx-5 py-0 compact-form">
            <v-col cols="6">
              <v-layout class="ma-2">
                <v-flex align-self-center md4><strong>Group:</strong></v-flex>
                <v-flex md8>
                  {{ delivery.customer_category }}
                </v-flex>
              </v-layout>
              <v-layout class="ma-2">
                <v-flex align-self-center md4><strong>Customer:</strong></v-flex>
                <v-flex md8>
                  {{ delivery.customer_name }}
                </v-flex>
              </v-layout>
              <v-layout class="ma-2">
                <v-flex align-self-center md4><strong>Status Botol:</strong></v-flex>
                <v-flex md8>
                  {{ delivery.bottle_status }}
                </v-flex>
              </v-layout>
              <v-layout class="ma-2">
                <v-flex align-self-center md4><strong>Volume:</strong></v-flex>
                <v-flex md8>
                  {{ delivery.bottle_size }} ml
                </v-flex>
              </v-layout>
            </v-col>
            <v-col cols="6">
              <v-layout class="ma-2">
                <v-flex align-self-center md4><strong>Tanggal Delivery:</strong></v-flex>
                <v-flex md8>
                  {{ delivery.delivery_date | moment }}
                </v-flex>
              </v-layout>
              <v-layout class="ma-2" v-if="delivery.expired_date">
                <v-flex align-self-center md4><strong>Tanggal Expired:</strong></v-flex>
                <v-flex md8>
                  {{ delivery.expired_date | moment }}
                </v-flex>
              </v-layout>
              <v-layout class="ma-2">
                <v-flex align-self-center md4><strong>Delivery Address:</strong></v-flex>
                <v-flex md8>
                  {{ delivery.delivery_address }}
                </v-flex>
              </v-layout>
            </v-col>
          </v-row>

          <v-row class="mb-2 mt-3">
            <v-col class="ml-6">
              <v-card outlined class="ma-3" width="800px">
                <v-simple-table fixed-header height="30vh" id="variantTbl">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">No</th>
                        <th class="text-left">Variant</th>
                        <th class="text-left">Qty Stock</th>
                        <th class="text-left">Qty Delivery</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(variant, vidx) in delivery.details" :key="vidx">
                        <td>{{ vidx + 1 }}</td>
                        <td>{{ getVariantName(variant.variant_code) }}</td>
                        <td>{{ variant.qty_stock || 0 }}</td>
                        <td>{{ variant.qty_delivered }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>   

        <v-divider></v-divider>
        <v-card-actions class="pr-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialog = false">Close</v-btn>
        </v-card-actions> 
      </v-card>
    </v-dialog>
    
    <v-overlay :value="onProgress" z-index="999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>        

  </div>
</template>

<script>
import moment from 'moment'

export default {
  data() {
    return {
      onProgress: false,
      dialog: false,
      do_no: null,
      delivery: {
        customer_category: null,
        customer_code: null,
        customer_name: null,
        delivery_date: null,
        expired_date: null,
        delivery_address: null,
        remarks: null,
        details: []
      }
    }
  },
  computed: {
    variants() {
      return this.$store.state.variant.objs
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('D MMMM YYYY');
    }
  },
  methods: {
    async openDialog() {
      this.dialog = true
      this.onProgress = true
      
      if (this.do_no) {
        // Fetch delivery order detail
        this.delivery = await this.$store.dispatch('deliveryorder/getObj', this.do_no)
        
        // Enrich details with variant info
        this.delivery.details.forEach(el => {
          const variant = this.variants.find(item => item.code === el.variant_code)
          if (variant) {
            this.$set(el, 'qty_stock', variant.qty_stock)
          }
        })
        
        console.log('Detail delivery:', this.delivery)
      }
      
      this.onProgress = false
    },

    getVariantName(code) {
      const variant = this.variants.find(v => v.code === code);
      return variant ? variant.name : '-';
    },

    getVariantVolume(code) {
      const variant = this.variants.find(v => v.code === code);
      return variant ? variant.size + ' ml' : '-';
    }
  }
}
</script>

<style>
  #orderform .col {
    padding: 5px!important;
  }
</style>
